<template>
  <article id="page-home" class="page page-home">
    <div ref="videoContainer" class="page-home-swiper">
      <div class="page-home-videos">
        <router-link 
          v-for="work in works" 
          :key="work.video" 
          class="page-home-videos-item"
          ref="video-items"
          :to="{name: 'player', params: {slug: playerSlug}}"
        >
          <video ref="video-elements" v-if="!$root.mobileDetected" loop muted :src="work.video"></video>
          <img v-else :src="work.image" alt="">
        </router-link>
      </div>
      <div ref="slider-container" class="page-home-slider">
        <button v-show="works.length" @click="() => handleSlide(-1)" class="page-home-slider-arrow left">
          <icon-arrow-left/>
        </button>
        <div class="page-home-slider-titles js-titles">
          <div class="page-home-slider-titles-client">
            <div class="js-bg js-bg-client bg">
              
            </div>
          </div>
          <div class="page-home-slider-titles-director">
            <div class="js-bg js-bg-director bg">
              
            </div>
          </div>
        </div>
        <router-link
          :to="{name: 'player', params: {slug: playerSlug}}"
          ref="slider-work-center" 
          class="page-home-slider-works"
        ></router-link>
        <button v-show="works.length" @click="() => handleSlide(1)" class="page-home-slider-arrow right">
          <icon-arrow-right/>
        </button>
      </div>
    </div>
    <router-view></router-view>
  </article>
</template>

<script>

// Components
import IconArrowLeft from '../icons/icon-arrow-left'
import IconArrowRight from '../icons/icon-arrow-right'
import IconArrowDown from '../icons/icon-arrow-down'

// Helpers
import Scene3d from '../../helpers/threejs/Scene3d'
import Cylinder from '../../helpers/threejs/Cylinder'
import Slider from '../../helpers/Slider'

// Modules
import * as THREE from 'three'
import gsap from 'gsap'

import {works as __data} from '../../__data'

// Utils
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'
import Utils from '../../utils/utils'

export default {
  name: 'PageHome',
  components: {
    "icon-arrow-left": IconArrowLeft,
    "icon-arrow-right": IconArrowRight,
    "icon-arrow-down": IconArrowDown,
  },
  data: function(){
    return {
      works: [],
      sliderInstance: null,
      touch: 0,
      playerSlug: "",
    }
  },
  beforeDestroy: function(){
    MyEmitter.emit(params.Events.stopSceneLogo)

    if(this.sliderInstance){
      this.sliderInstance.stop()
    }
  },
  beforeRouteLeave(to, from, next){    
    if(to && to.name !== "work" && to.name !== "player"){

      let isMobile = this.$root.mobileDetected

        gsap.to(this.$el, {
          duration: 1.2,
          opacity: 0,
        })

      MyEmitter.emit(params.Events.logoGoHeader, undefined, () => {
        next()
      }, isMobile)
    } 
    
    else if(to && to.name !== "player"){
      this.$el.style.opacity = 0
      next()
    } else {
      // can only be /work which is children route so it trigger routeUpdate() but ... au cas ou
      next()
    }
  },
  beforeRouteEnter (to, from, next) {

    // store prev route
    next(vm => {
      vm.prevRoute = from
    })

    // come from any page except work AND to home
    if(from && from.name && from.name !== "work" && to.name === "home"){
      next(vm => {

        gsap.from(vm.$el, {
          duration: 1.2,
          opacity: 0,
        })

        MyEmitter.emit(params.Events.logoGoMiddle)
      })
    } 
    // appears at HOME
    else if(from && !from.name && to.name === "home"){
      next()
    }
    else {
      next()
    }

  },
  beforeRouteUpdate(to, from, next){  
  
  // from home -> work
    if(to.name === "work"){
      // !
      this.sliderInstance && this.sliderInstance.stop()
      this.removeOnceEvents()
    }

    next()
  },
  mounted: function(){

    // on WORK
    if(this.$route.name === "work"){
      
      // on DESKTOP
      if(!this.$root.mobileDetected){
        this.$el.style.transform = "translate(0, -100vh)"
      }
    } 
    // on HOME
    else if(this.$route.name === "home"){
      setTimeout(() => {
          this.attachOnceEvents()
      }, 500)
      this.fetchSliderInfos()
    }

    
  },
  methods: {
    

    setSliderData(res){
      this.works = res.map((slide, slideIndex) => {

          let slug = slide.slug
          let director = slide.director
          let client = slide.client

          if(!slug){
              console.warn("slide " + slideIndex + " do not have slug")
              slug = ""
          }

          if(!director){
              console.warn("slide " + slideIndex + " do not have director")
              director = ""
          }

          if(!client){
              console.warn("slide " + slideIndex + " do not have client")
              client = ""
          }

          return {
            id: slideIndex,
            video: slide.preview,
            image: slide.image,
            director,
            client,
            slug,
          }
        })
    },

    startSlider(){
      let clientList = this.works.map(w => w.client)
      let directorList = this.works.map(w => w.director)

      let videoItems = this.$refs["video-items"].map(ref => ref.$el)

      this.sliderInstance = new Slider(this.$refs["slider-container"], videoItems, this.$refs["slider-work-center"], this.$root.mobileDetected, {
        clientList,
        directorList
      })

      this.sliderInstance.onSlided = this.onSliderSlided

      if(this.$route.name === "home"){

        // only start slider right away if we are coming from another page
        if((this.prevRoute && this.prevRoute.path !== "/") || !this.prevRoute){
          this.sliderInstance.start()
        } else {
          MyEmitter.on(params.Events.onLoaderEnd, () => {
            this.sliderInstance.start()
          })
        }

      }
    },

    fetchSliderInfos: async function(){
      
      let res = await Utils.fetch("/slider")

      this.setSliderData(res)
      // wait for data.works is set
      await this.$nextTick()


      // set first player slug link
      this.playerSlug = this.works[0].slug
  
      // load slider image and start slider
      if(this.$root.mobileDetected){

        Utils.waitForRessourcesImages(this.works.map(w => w.image), () => {

          this.startSlider()

        })
      } 
      
      // wait for videos slider loaded then start slider
      else {


          let videoElements = this.$refs["video-elements"].map((ref, index) => ({
            element: ref,
            src: this.$refs["video-elements"][index].src
          }))

          Utils.waitForRessourcesVideos(videoElements, () => {
            this.startSlider()
          })
      }
    },

    onSliderSlided: function(nextIndex){
      this.playerSlug = this.works[nextIndex].slug
    },

    handleSlide: function(...args){
      this.sliderInstance.handleSlide(...args)
    },

    handleScrollToWork: function(event){

      let direction = Math.sign(event.deltaY)

      if(direction > 0){
        this.goToPageWork()
      }
    },

    goToPageWork: function(){
      this.$router.push("/work")
    },

    handleTouchStart(event){
      this.touch = {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY,
      }
    },

    handleToucheEnd(event){

      let current = {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY,
      }

      let difference = {
        x: current.x - this.touch.x,
        y: current.y - this.touch.y,
      }

      // scroll horizontal
      if( Math.abs(difference.x) > 50 ){

        let direction = -Math.sign(difference.x)
        this.handleSlide(direction)
      } 
      // scroll vertical
      else if(difference.y < -50){
        this.goToPageWork()
      }
    },

    removeOnceEvents(){

        this.$refs.videoContainer.removeEventListener("wheel", this.handleScrollToWork)

        // Mobile
        if(this.$root.mobileDetected){
          this.$refs.videoContainer.removeEventListener("touchstart", this.handleTouchStart)
          this.$refs.videoContainer.removeEventListener("touchend", this.handleToucheEnd)
        }
    },

    attachOnceEvents: function(){
      
      this.$refs.videoContainer.addEventListener("wheel", this.handleScrollToWork)

      // Mobile
      if(this.$root.mobileDetected){
        this.$refs.videoContainer.addEventListener("touchstart", this.handleTouchStart)
        this.$refs.videoContainer.addEventListener("touchend", this.handleToucheEnd)
      }
    },
  }
}
</script>

<style lang="scss">

  .page-home{
    position: relative;
    overflow-y: auto;

    @include desktop{
      overflow-y: initial;
    }

    &-swiper{
      position: relative;
      height: 100%;
    }

    &-nav{
      @extend %absolute-center-y;
      width: 100%;
      z-index: 3;
      display: flex;
      justify-content: space-between;
      padding: 0 60px;
      pointer-events: none;

      &-part{
        display: flex;
      }

      &-item{
        display: inline-block;

        &:first-child{
          max-width: 200px;
          width: 14vw;
        }
      }


      &-links{
        font-size: ptToPx(11);
        text-transform: uppercase;
        letter-spacing: 4px;
        pointer-events: all;        
      }
    }
    
    &-videos{
      z-index: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;

      &-item{
        @include absolute-fullscreen();
        width: 100%;
        z-index: 1;
        opacity: 0;

        &.current{
          z-index: 2;
          opacity: 1;
        }

        &.next{
          z-index: 3;
          opacity: 1;
        }

        video, img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;

          // hacks
          // filter: brightness(.5)
        }
      }
    }

    &-slider{
      @extend %absolute-center;
      z-index: 2;
      width: 100%;
      padding: 0 39px;
      display: flex;
      justify-content: space-between;

      @include very-small{
        padding: 0 0px;
      }

      &-titles{
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        pointer-events: none;

          .bg{
              background: linear-gradient(to right, #fff 50%, rgba(255, 255, 255, .5) 50%);
              background-size: 200% 100%;
              background-position-x: 0%;
              background-clip: text;
              -webkit-background-clip: text;
              color: transparent;
              display: inline-block;

              div{
                border: 1px solid red;
              }
          }

          &-client{
            text-transform: uppercase;
            font-weight: 700;
            letter-spacing: 6px;
            margin-bottom: 7px;
            font-size: 20px;

            @include desktop{
              font-size: ptToPx(14);
            }

            @include very-small{
              font-size: ptToPx(12);
              margin-bottom: 3px;
              letter-spacing: 4px;
            }
          }

          &-director{
            text-transform: uppercase;
            font-size: ptToPx(11);
            font-weight: 200;
            letter-spacing: 6px;
            font-size: 16px;

            @include desktop{
              font-size: ptToPx(14);
            }

            @include very-small{
              font-size: ptToPx(10);
              letter-spacing: 4px;
            }
          }

      }

      &-arrow{
        min-width: 40px;
        padding: 10px 0;
        transition: ease-out 250ms;
        transition-property: opacity;
        position: relative;
        z-index: 10000;

        @include very-small{
          min-width: 30px;
          .icon{
            height: 10px
          }
        }

        &:hover{
          opacity: .5
        }
      }

      &-works{
        width: 100%;
        position: relative;

        &-item{
          @extend %hidden;
          @extend %absolute-center;
          width: 100%;
          display: flex;
          flex-direction: column;
          position: absolute;
          text-align: center;
        }
      }

      @include desktop{
        justify-content: center;

        &-works{
          width: 25vw; // related to heade's logo width
        }
      }
    }

    &-gotowork{
      @extend %absolute-center-x;
      bottom: 15px;

    }
  }
</style>

